module.exports = __webpack_public_path__ + "static/media/p3_6.d832ca5e.png";